import { ReactElement } from 'react';
import { DeclineReferralValues, RegisterContactAttemptValues } from '../../types';

export interface SchedulerInquiryProps {
  disabled: boolean;
  handleContactAttempt: (data: RegisterContactAttemptValues) => void;
  handleDeclineReferral: (data: DeclineReferralValues) => void;
  handleInquiryChange: (showScheduler: boolean, inquiry: Inquiry) => void;
  isContactAttemptSuccess: boolean;
}

export interface RadioGroupProps {
  children: ReactElement;
}

export interface Inquiry {
  consentToGeneticCounselingAt?: string;
  consentToShareResultsAt?: string;
  declineReason?: DeclainedReasonId;
  declineReasonDescription?: string;
  geneticCounselingConsent?: boolean;
  patientContacted?: boolean;
  resultsSharingConsent?: boolean;
}

export enum PatientContactOptionId {
  CONTACTED = 'contacted',
  UNABLE_TO_CONTACT = 'unable-to-contact',
}

export enum GCConsentOptionId {
  GC_ACCEPTED = 'genetic-counseling-accepted',
  GC_DECLINED = 'genetic-counseling-declined',
}

export enum DeclainedReasonId {
  ALREADY_AWARE_OF_RESULT = 'already-aware-of-result',
  ALREADY_RECEIVED_GC = 'already-received-gc',
  DOES_NOT_WANT_TO_SHARE = 'does-not-want-to-share',
  MULTIPLE_ATTEMPTS_MADE = 'multiple-attempts-made',
  NOT_INTERESTED = 'not-interested',
  OTHER = 'other',
}

export enum ResultsSharingOptionId {
  RESULTS_SHARING_ACCEPTED = 'results-sharing-accepted',
  RESULTS_SHARING_DECLINED = 'results-sharing-declined',
}

export enum ActionType {
  CONTACT = 'contact',
  DECLINE = 'decline',
  GENETIC_COUNSELING_CONSENT = 'consent-genetic-counseling',
  RESULTS_SHARING_CONSENT = 'consent-results-sharing',
  RESET = 'reset',
}

export interface SchedulerAction {
  payload?: {
    declineReason?: string;
    value?: boolean;
    timestamp?: string;
  };
  type: ActionType;
}
